import type {
  CreateMcpTokenBody,
  McpTokenCreated,
  McpTokenListItem,
} from '../types/mcpToken';
import { IGetAllResponse, IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export class McpTokenService extends ApiService {
  static pathName = (workspaceId: string) =>
    `/workspaces/${workspaceId}/mcp-tokens`;

  static list = (
    workspaceId: string,
  ): Promise<IGetAllResponse<McpTokenListItem>> => {
    return ApiService.get(McpTokenService.pathName(workspaceId));
  };

  static create = (
    workspaceId: string,
    body: CreateMcpTokenBody,
  ): Promise<IGetOneResponse<McpTokenCreated>> => {
    return ApiService.post(McpTokenService.pathName(workspaceId), body);
  };

  static revoke = (
    workspaceId: string,
    tokenId: string,
  ): Promise<Record<string, never>> => {
    return ApiService.delete(
      `${McpTokenService.pathName(workspaceId)}/${tokenId}`,
    );
  };
}
